import type { FC } from "react";
import { AdminDashboardPage } from "./AdminDashboardPage";

const AdminDashboardPageContainer: FC = () => {
  return <AdminDashboardPage />;
};

export default AdminDashboardPageContainer;
